/**
 * Selected-count action bar (Task 4) — the floating bar that appears when one or
 * more rows are selected, showing the count, the bulk actions (passed as
 * children, e.g. Create batch), and a clear control. Shared so every list's bulk
 * actions read the same. Sits above content but below popovers/drawer; pairs with
 * the back-to-top button without overlapping (this is centred, that is right).
 */
import type { ReactNode } from "react";
import { Icon } from "./Icon.js";

export function SelectionBar({
  count,
  onClear,
  children,
}: {
  count: number;
  onClear: () => void;
  children: ReactNode;
}) {
  if (count === 0) return null;
  return (
    <div className="selection-bar" role="region" aria-label="Bulk actions">
      <span className="selection-bar__count">
        <strong>{count}</strong> selected
      </span>
      <div className="selection-bar__actions">{children}</div>
      <button type="button" className="selection-bar__clear" onClick={onClear} aria-label="Clear selection">
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
